import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';
import { Funding } from '@finley-technologies/finley-types';

import { Typography } from '~/packages/common-frontend/components/Typography';
import { percentageToPercentageLabel } from '~/packages/common-frontend/utils';

type MarginType = Funding.LoanMechanics['pricingOptions'][number]['margin'];

type MarginProps = {
  margin: MarginType;
};

export const Margin = ({ margin }: MarginProps) => {
  return (
    <>
      <Typography variant="section-subtitle">Margin</Typography>
      <TableContainer w="100%">
        <Table borderWidth="1px">
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Value</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>Type</Td>
              <Td>{commonUtils.toTitleCase(margin.type)}</Td>
            </Tr>
            <Tr>
              <Td>Value</Td>
              <Td>{percentageToPercentageLabel(margin.value * 100, 4)}</Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
};
